import { Component, Inject, ChangeDetectorRef, ViewEncapsulation, AfterViewChecked, ComponentFactoryResolver, ComponentRef, ElementRef, OnDestroy } from '@angular/core';
import { SensorObject } from '../asp/SensorObject';
import { AroService } from '@core_n/aro/aro.service';
import { AroAngularTrackCoreComponent } from '@core_n/aro/aro-angularTrack-core.component';
import { AroTrackTabGenComponent } from './aro-track-tab-gen.component';
import { AroTrackTabMnvrComponent } from './aro-track-tab-mnvr.component';
import { AroTrackTabClassificationComponent } from './aro-track-tab-classification.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserActionService } from '@core_n/user-action/user-action.service';
import * as utils from '@core_n/common/utils';
import * as aspObjects from './../../core/app/asp/aspObjects';
import { AcousticVectorObject } from '@core_n/asp/AcousticVectorObject';


@Component({
  templateUrl: '../../core/app/aro/aro-angularTrack-core.component.html',
  styleUrls: ['../../core/app/aro/aro.component.scss']
})


export class AroAngularTrackComponent extends AroAngularTrackCoreComponent implements AfterViewChecked {

  constructor(public dialogRef: MatDialogRef<AroAngularTrackComponent>,
    private userActionSrv: UserActionService,  
    elementRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) data: any,
    aroService: AroService,
    cdref: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver) {
     
     super(aroService, cdref, elementRef, dialogRef);

     this.tab2Label = 'Classiff';
    // this.showNationality = true;
    // this.majorEditable = true;
    // this.minorEditable = true;
    // this.identityEditable = true;
    // this.tab3Label = 'Classiff';
    // this.tab4Label = 'Maneuver';
  }

  ngAfterViewChecked(): void {
    this.cdref.detectChanges();
  }

  protected getTabComponentFactory(tabIndex: number) {
    if (tabIndex == 2)
      return this.componentFactoryResolver.resolveComponentFactory(AroTrackTabGenComponent);
    if (tabIndex == 3)
      return this.componentFactoryResolver.resolveComponentFactory(AroTrackTabClassificationComponent);
    if (tabIndex == 4)
      return this.componentFactoryResolver.resolveComponentFactory(AroTrackTabMnvrComponent);
    else
      return null;
  }

  protected refresh(force: boolean = false): void {
    super.refresh(force);
    if ((this.shown || force) && this.angTrack != null) {
      this.cdref.detectChanges();
    }
  }

  showMissileData(): boolean {
    // return this.isMissile || !this.isAbt;
    return false;
  }

  showFlightProgress(): boolean {
    return false;
  }

  setAngTrack(angTrack: AcousticVectorObject) {
    this.angTrack = angTrack;
    this.shown = true;
    this.sensor = aspObjects.sensorsPool.getSensorBySicSac(this.angTrack.Data.SnsID, 0) as SensorObject;
  }

  static createDialogConfig(angTrack: AcousticVectorObject) {
    let dialogConfig = utils.createDialogConfig(false);
    dialogConfig.data = { track: angTrack };
    return dialogConfig;
  }
}
